import { useState } from "react";
import moment from "moment";

import { DateRangePicker } from "@cofano/cck";
import { StyledFilterInputlabel } from "@cofano/cck/Table/Styled";

type WeekRangePickerProps = {
	value?: [number | null, number | null];
	onChange: (value: [number | null, number | null] | null) => void;
	onFocus?: () => void;
	onBlur?: () => void;
	onCalendarOpen?: () => void;
	onCalendarClose?: () => void;
};

const WeekRangePicker = ({ value, onChange, onFocus, onBlur, onCalendarOpen, onCalendarClose }: WeekRangePickerProps) => {
	return (
		<DateRangePicker
			startDate={value?.[0] ? moment(value[0]).toDate() : undefined}
			endDate={value?.[1] ? moment(value[1]).toDate() : undefined}
			onChange={window => {
				const from = window[0] ? moment(window[0]).unix() * 1000 : null;
				const to = window[1] ? moment(window[1]).unix() * 1000 : null;
				onChange((from || to) ? [ from, to ] : null);
			}}
			dateFormat={"I"}
			portalId={"date-picker-container"}
			onFocus={onFocus}
			onBlur={onBlur}
			onCalendarOpen={onCalendarOpen}
			onCalendarClose={onCalendarClose}
			showWeekNumbers
			showWeekPicker
			isClearable={true}
			popperPlacement={"bottom-start"}  />
	);
};

type WeekRangePickerQuickFilterProps = {
	label?: string
} & Pick<WeekRangePickerProps, "value" | "onChange">;

export const WeekRangePickerQuickFilter = ({ label, value, onChange }: WeekRangePickerQuickFilterProps) => {

	const [ hasFocus, setFocus ] = useState(false);
	const [ open, setOpen ] = useState(false);

	return (
		<StyledFilterInputlabel shrink={hasFocus || (value?.[0] ? true : false)} hasFocus={hasFocus || open}>
			<label>{label}</label>

			<WeekRangePicker
				value={value}
				onChange={onChange}
				onFocus={() => setFocus(true)}
				onBlur={() => setFocus(false)}
				onCalendarOpen={() => setOpen(true)}
				onCalendarClose={() => setOpen(false)} />
		</StyledFilterInputlabel>
	);
};

export default WeekRangePicker;
